<template>
          <div class="move-container" style="padding-left: 10px;padding-right: 10px;">
      <div style="float: left;padding-top:25px; margin-right: 10px;">Movie Time
</div>
     <div style="float: left; padding-top: 10px; padding-bottom: 20px;">


    <button v-for="(show, index) in showTime" :key="index" :data-toggle="show.isonline == 0 ? 'modal' : 'modal'"
    :data-target="show.isonline == 0?'#largeModal':'#smallmodal'" class="tim goScreen bg4 text-center tibttn"
    :style="$route.params.showid == show.id ? { 'background-color': 'rgb(254, 187, 23) !important' } : { 'background-color': fillColor(show.booked, show.seats, show.isonline) }"
    @click="routechange(show.id,show.isonline)">
    <span class="linht">
      {{ show.stime }}
      <div class="scnb">{{ show.screen }}</div>

      <div class="spck">{{ show.exp }}</div>
    </span></button>
<div>
<div>
</div> 
</div>
        
     
        
</div>
    
</div>

</template>



<script>
export default {
  data:()=>({
    showId:null,
  }),
     props: ['showTime'],
  methods: {
     routechange(showId,ison){
      if(ison!=1){
        this.showId=showId;
        this.$router.replace({path:"../seatlayout/"+showId});
      }
    },
    
    fillColor(cnt, seats, ison) {
      
      if (ison != 0) {
        return 'rgb(204,204,204)';
      }
      var blprc = cnt / seats;
      var r = 233;
var g = Math.floor(233 * (1 - blprc) + 17 * blprc);
var b = Math.floor(237 * (1 - blprc) + 0 * blprc);
      return 'rgb(' + r + ',' + g + ',' + b + ')';
    }
  },
  mounted(){
    this.showId=this.$route.params.showid;
  }
}
</script>